module.exports = __webpack_public_path__ + "img/image 22.9513065b.svg";